export default {
  options: {
    true: 'Kyllä',
    false: 'Ei',
  },
};
